import {
  AdminDatePickerInputModal,
  AdminRadioInput,
  Button,
  ChatPauseIcon,
  Disclaimer,
  Div,
  ErrorToast,
  H3,
  Modal,
  P,
  lightTheme,
} from '@vgrubs/components';
import { MenuItemV2Response } from 'components/src/types/menu.types';
import { useEffect, useState } from 'react';
import { PauseBadge } from '../../MenyStyled';
import {
  ItemPause,
  PAUSE_CHOICE_LABELS,
  PAUSE_IN_PAST_ERROR,
  PauseChoice,
  defaultPauseUntil,
  isPauseInFuture,
  itemPauseBody,
  locationZoneNote,
  pauseUntilFormat,
} from './itemPause.helpers';

const CHOICES: PauseChoice[] = ['indefinitely', 'endOfDay', 'custom'];

export const PauseItemModal = ({
  item,
  timeZone,
  closeModal,
  handlePause,
}: {
  item: MenuItemV2Response | null;
  timeZone?: string;
  closeModal: () => void;
  handlePause: (pause: ItemPause) => void;
}) => {
  const [choice, setChoice] = useState<PauseChoice>('indefinitely');
  const [until, setUntil] = useState<Date[]>([]);
  // Kept past close, so the name does not vanish while the modal animates out.
  const [name, setName] = useState('');

  useEffect(() => {
    if (!item) return;
    setName(item.name);
    setChoice('indefinitely');
    setUntil([defaultPauseUntil(timeZone)]);
  }, [item]);

  const zoneNote = locationZoneNote(timeZone);

  const handleConfirm = () => {
    if (choice === 'custom' && !isPauseInFuture(until[0], timeZone)) {
      return ErrorToast(PAUSE_IN_PAST_ERROR);
    }
    handlePause(itemPauseBody(choice, until[0] ?? null));
  };

  return (
    <Modal isOpen={!!item} closeModal={closeModal} logo={false}>
      <PauseBadge>
        <ChatPauseIcon color={lightTheme.white} />
      </PauseBadge>
      <H3 $mb="8" $color={lightTheme.darkGray}>
        Pause Item
      </H3>
      <P $mb="24">{name}</P>

      <Div $flex $column $gap="8px" $mb="32">
        {CHOICES.map((value) => (
          <AdminRadioInput
            key={value}
            checked={choice === value}
            onClick={() => setChoice(value)}
            label={PAUSE_CHOICE_LABELS[value]}
            shadowDesign
          />
        ))}

        {choice === 'custom' && (
          <Div $mt="8">
            <AdminDatePickerInputModal
              label="Paused Until"
              format={pauseUntilFormat}
              value={until}
              onChange={setUntil}
              options={{ minDate: 'today' }}
              beforeApplyValidation={([date]) =>
                date && isPauseInFuture(date, timeZone)
                  ? null
                  : PAUSE_IN_PAST_ERROR
              }
              $textCenter
            />
            {zoneNote && (
              <Disclaimer $m="8px 0 0" $center $color={lightTheme.darkGray}>
                {zoneNote}
              </Disclaimer>
            )}
          </Div>
        )}
      </Div>

      <Button $selected $w="100%" $mb="8" onClick={handleConfirm}>
        Confirm
      </Button>
      <Button $selected $w="100%" $gray onClick={closeModal}>
        Cancel
      </Button>
    </Modal>
  );
};
